<template>
  <div class="pdf_dialog"  v-loading="loading" 
    :element-loading-text="$t('seller.upload.aiAutoFill')"
  >
    <div class="drak"></div>
    <div class="pdf_content">
      <md-card>
        <md-card-content style="height:100%">
          <div class="md-layout" style="height:100%;overflow:auto">
            <div class="close_box" @click.stop="close">
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </div>
            <div class="pdf_list">
              <EditPdfLeft :getDetail="getDetail" :activeId="activeId"></EditPdfLeft>
            </div>
            <div class="md-layout-item pdf_iframe flex_3">
              <PdfView></PdfView>
            </div>
            <div class="md-layout-item pdf_form">
              <PdfForm :getDetail="getDetail"></PdfForm>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import PdfView from "./PdfView";
import PdfForm from "./PdfForm";
import EditPdfLeft from "./EditPdfLeft";
import {mapGetters} from "vuex";
import {receivableApi} from "@/common/api/receivableApi";

export default {
  components: {
    PdfView,
    PdfForm,
    EditPdfLeft
  },
  data() {
    return {
      filImg: require("@/assets/img/file-icon.png"),
      pdfStatus: 3,
      saveNum: 0,
      submitNum: 0,
      activeId: "",
      loading:false
    };
  },
  created() {
    // tableItemData
    if (this.pafList && this.pafList.length > 0) {
        let id = this.pafList[0].receivableId;
        this.getDetail(id);
      this.$store.dispatch("setActionActivePdf", this.pafList[0]);
    }
  },
  mounted() {
    // receivableDetail
  },
  methods: {
    close() {
      this.$store.dispatch("setActionTableItemDetail", "");
      this.$store.dispatch("setActionPdfDialog", { show: false });
    },
    getDetail(id) {
      this.activeId = id;
      this.loading=true
      receivableApi
        .receivableDetailWithAiAutoFills(id)
        .then(res => {
          this.$store.dispatch("setActionTableItemDetail", res);
          if (res.errorMsg) {
            this.toast(res.errorMsg);
          }
          if (res.aiRecognized) {
            this.toast(this.$t('seller.upload.aiAutoFill.success'), 'warning')
          }
          this.loading=false;
        })
        .catch(err => {
          this.toast(err);
          this.loading=false
        });
    },
  
  },
  computed: {
    ...mapGetters({
      tableItemData: "tableItemData",
      pafList: "pafList"
    })
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/base_variables.scss";

#app {
  .router_view {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }
}
.pdf_dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  .pdf_list_box {
    overflow-y: auto;
    overflow-x: hidden;
  }
  .close_box {
    position: absolute;
    right: 0;
    top: 0;
    height: 50px;
    width: 50px;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
  }
  .drak {
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0,0,0,0.2);
    left: 0;
    top: 0;
    z-index: 1;
  }
	.pdf_form {
		min-width: 500px;
	}
  .pdf_content {
    width: 90%;
    height: 100%;
    max-width: 3000px;
    position: absolute;
    text-align: center;
    left: 50%;
    top: 50%;
    z-index: 20;
    transform: translate(-50%, -50%);
    display: flex;
    .pdf_list {
      text-align: center;
	  max-width: 10%;

      .pdf_item {
        position: relative;
        margin-bottom: 30px;
        &.active_pdf {
          border: 1px solid $accent-color;
        }
        cursor: pointer;
        .pdf_status {
          position: absolute;
          top: 0;
          right: 70%;
          i {
            font-size: 1.28rem;
          }
        }
        i.file_bg {
          font-size: 3rem;
        }
      }
    }
  }
}
</style>
